import controller from './change-volume.controller';
import template from './change-volume.html';

export default { controller, template };



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/components/widgets/change-volume/change-volume.component.js